module.exports = "/_next/static/images/939c06f9dfc20036bfbad9287e4c5e08-app-screenshots-xs@1x.jpg";